import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router'
import { useAuthStore } from '@/store/auth-store'
import { PageLoader } from '@/shared/components/page-loader'

// The account state screens sit outside both the public and the protected layout, so
// nothing was loading the session for them. Arriving by redirect happened to work because
// the store was already populated, but a reload left them with no profile at all, and
// signing out changed the status with nothing watching it. This owns both concerns.
export function AccountStatusLayout() {
  const status = useAuthStore((s) => s.status)
  const initialize = useAuthStore((s) => s.initialize)
  const { pathname } = useLocation()

  useEffect(() => {
    initialize()
  }, [initialize])

  if (status === 'loading') return <PageLoader />
  if (status === 'unauthenticated') return <Navigate to="/login" replace />
  if (status === 'no-profile') return <Navigate to="/signup" replace />
  if (status === 'authenticated') return <Navigate to="/" replace />

  // Each status has exactly one screen that explains it, so do not let the other one show.
  if (status === 'inactive' && pathname !== '/account-review') {
    return <Navigate to="/account-review" replace />
  }
  if (status === 'wrong-role' && pathname !== '/access-denied') {
    return <Navigate to="/access-denied" replace />
  }

  return <Outlet />
}
